import { TypeKeys } from './actionsUtils.js';

export interface FooterVisibilityAction {
  type: TypeKeys.FOOTER_SET_VISIBILITY;
  footerVisible: boolean;
}

export const setFooterVisibility = (footerVisible: boolean): FooterVisibilityAction => ({
  footerVisible,
  type: TypeKeys.FOOTER_SET_VISIBILITY,
});

export interface SmallHeaderVisibilityAction {
  type: TypeKeys.SMALL_HEADER_SET_VISIBILITY;
  smallHeaderVisible: boolean;
}

export const setSmallHeaderVisibility = (smallHeaderVisible: boolean): SmallHeaderVisibilityAction => ({
  smallHeaderVisible,
  type: TypeKeys.SMALL_HEADER_SET_VISIBILITY,
});

export type LayoutActionTypes = FooterVisibilityAction | SmallHeaderVisibilityAction;
